import { cn } from '@commenda/utils';
import React from 'react';

import { Badge, type BadgeProps } from '../../Badge';
import { TruncatedText } from '../../TruncatedText';
import { DataGridAlign } from '../types';
import { getDataGridJustifyClass } from '../utils';

export interface DataGridCellTextBadgeChip {
  label: React.ReactNode;
  variant?: BadgeProps['variant'];
}

export interface DataGridCellTextBadgeProps {
  children: React.ReactNode;
  badge: DataGridCellTextBadgeChip;
  leading?: React.ReactNode;
  align?: DataGridAlign;
  className?: string;
}

const DataGridCellTextBadge = ({
  children,
  badge,
  leading,
  align = 'left',
  className,
}: DataGridCellTextBadgeProps) => (
  <div
    className={cn(
      'flex w-full items-center gap-md',
      getDataGridJustifyClass(align),
      className
    )}
  >
    {leading}
    <TruncatedText className="txt-small-regular text-text-primary">
      {children}
    </TruncatedText>
    <Badge size="sm" variant={badge.variant}>
      {badge.label}
    </Badge>
  </div>
);

export { DataGridCellTextBadge };
